import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinFactory from "../../../core/ui/SkinFactory";
import EmailInteractionEvent from "../controller/EmailInteractionEvent";
import EmailConversationViewConstants from "./EmailConversationViewConstants";

export default class EmailDraftOptionOverlayMediator extends AbstractMediator {

    constructor(target, dispatcher, languagePack, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        
        this._languagePack = languagePack;
        
        this._mcBlock = this.getCustomData().mcBlock;
        this._skinKeyRegistry = this.getCustomData().skinKeyRegistry;

        this._buttons = [];
    }

    initialize() {
        super.initialize();

        this._target.pickAnswerTextField.initialY = this._target.pickAnswerTextField.y;
        this._target.pickAnswerTextField.text = this._languagePack.getText("email.pickAnswerLabel");
        let y = 0;
        
        const options = this._mcBlock.getOptions();

        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            const buttonText = option.getValue().getText() || option.getDescription().getText();
            let button = this._createButton(buttonText, this._handleOptionPicked.bind(this), i == this._mcBlock.getSelectedOptionIndex(), false);
            button.customData = {option: option};
            button.skin.y += y;
            y += button.skin.getBounds().height;
            this._target.container.addChild(button.skin);
        }

        // Add cancel button
        let cancelButton = this._createButton("Cancel", this._handleCancelClicked.bind(this), false, true);
        cancelButton.skin.y += y + EmailConversationViewConstants.ITEM_SPACING;
        this._target.container.addChild(cancelButton.skin);

        // Vertically center everything
        const optionBounds = this._target.container.getBounds();
        const optionsHeight = optionBounds.height;
        const optionsY = optionBounds.y;
        this._target.pickAnswerTextField.y = -(optionsHeight + optionsY) * .5 + this._target.pickAnswerTextField.initialY;
        this._target.container.y = -(optionsHeight + optionsY) * .5;

        this.preventClickThrough();
    }

    destroy() {
        for (let i = 0; i < this._buttons.length; i++) {
            this._buttons[i].destroy();
        }
        this._buttons = null;

        super.destroy();
    }

    _handleOptionPicked(event) {
        const option = event.target.customData.option;
        this._mcBlock.setSelectedOption(option);
        this.dispatch(EmailInteractionEvent.DRAFT_CHOICE_PICKED);

        this._close();
    }

    _handleCancelClicked(event) {
        this._close();
    }

    _close() {
        this.dispatch(EmailInteractionEvent.CLOSE_DRAFT_CHOICE_PICKER);
    }

    _createButton(label, boundClickHandler, isChecked, isCancel) {
        const states = ['up', 'down', 'over', 'disabled'];

        const buttonSkin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_DRAFT_OPTION_OVERLAY_BUTTON_SKIN);
        for (let i = 0; i < states.length; i++) {
            const state = states[i];
            const stateSkin = buttonSkin[state];
            if (!stateSkin) {
                continue;
            }

            stateSkin.checkmark.visible = isChecked;
            stateSkin.backArrow.visible = isCancel;
        }
        
        const button = this.createSlice9Button(buttonSkin, boundClickHandler, label);
        this._buttons.add(button);
        return button;
    }
}